import { render, staticRenderFns } from "./DrStatistics.vue?vue&type=template&id=41b090f5&"
import script from "./DrStatistics.vue?vue&type=script&lang=js&"
export * from "./DrStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports